/** Feste Rechteschlüssel (ADR-003). Neue Module ergänzen ihre Rechte hier und als Zeilen in app_gruppenrechte. */
export const RECHTE = [
  "aufgaben.eigene",
  "aufgaben.mitglieder_lesen",
  "aufgaben.anlegen_offen",
  "aufgaben.vorstand_lesen",
  "aufgaben.alle_bearbeiten",
  "sprint.planen",
  "vorhaben.verwalten",
  "finanzen.verwalten",
  "sitzung.leiten",
  "termine.verwalten",
  "protokolle.lesen",
  "protokolle.freigeben",
  "ablage.lesen",
  "ablage.verwalten",
  "eingang.lesen",
  "zugaenge.vorstand_vergeben",
  "zugaenge.verwalten",
  "redaktion.newsletter",
  "redaktion.website",
  "redaktion.freigeben",
] as const;

export type Recht = (typeof RECHTE)[number];

export function istRecht(s: string): s is Recht {
  return (RECHTE as readonly string[]).includes(s);
}
